import * as React from "react";
import {useState} from "react";
import {MuiFileInput} from "mui-file-input";
import {prepareUploadImage, uploadImage} from "../service/ImageService";
import {Alert, ProgressBar} from "react-bootstrap";
import pLimit from "p-limit";


export default function ImageUpload(props) {
    // const selectedUser = useSelector((state) => state.user.selectedUser)
    // const activeQuote = useSelector((state) => state.cart[selectedUser.id]?.activeQuote)
    const {job, images, setImages} = props;
    const [isUploading, setIsUploading] = useState(false)
    const [uploadPercentage, setUploadPercentage] = useState(0);


    const [files, setFiles] = useState(null);

    function delayOneSecond() {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 1000); // 1000 milliseconds = 1 second
        });
    }

    const compressImage = (file, maxWidth = 1920, maxHeight = 1080, quality = 0.7) => new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            let width = img.width;
            let height = img.height;

            // Calculate the new dimensions
            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }

            // Create canvas
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            // Convert canvas to blob
            canvas.toBlob((blob) => {
                resolve(new File([blob], file.name, {
                    type: file.type,
                    lastModified: Date.now()
                }));
            }, file.type, quality);
        };
        img.onerror = reject;
    });

    function isImageFile(image_type) {
        // List of image extensions (add more if needed)
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "webp", "svg"];
        return imageExtensions.includes(image_type);
    }

    const limit = pLimit(6);
    const handleUpload = async (files) => {
        let pendingImages = [];
        const progressArray = new Array(files.length).fill(0); // Initialize progress array

        setIsUploading(true);

        setFiles(files);

        const updateTotalProgress = () => {
            const totalProgress = progressArray.reduce((acc, curr) => acc + curr, 0) / files.length;
            const totalProgressRounded = Number(totalProgress.toFixed(2));
            setUploadPercentage(totalProgressRounded);
        };

        await Promise.allSettled(files.map(((file,index) => limit(async () => {
            const fileType = file?.type?.split("/")[1]?.toLowerCase() || "unknown";
            const fileName = file?.name || "unknown";

            if (isImageFile(fileType)) {
                // Compress image if it's an image
                file = await compressImage(file);
            }
            await prepareUploadImage(fileName, fileType, job.cos_job_id).then(async (response) => {
                if (response.status === 200) {
                    let data = await response.json();
                    let signedUrl = data.upload_url;

                    await uploadImage(signedUrl, file, (percentage) => {
                        progressArray[index] = percentage; // Update this file's progress
                        updateTotalProgress(); // Update total progress
                    });

                    pendingImages.push(data);
                } else {
                    console.error(response);
                }
            });
        })))).then((results) => {
            setFiles(null);
            setIsUploading(false);
            setUploadPercentage(0);
            delayOneSecond().then(() => {
                setImages([...images ?? [], ...pendingImages], job.cos_job_id);
            });
        });
    };

    return (

        <>
            <MuiFileInput
                sx={{mt: 1}}
                type="file"
                inputProps={{accept: "image/*, video/*, application/pdf"}}
                placeholder="Click to Insert your images"
                multiple
                disabled={isUploading}
                value={files}
                onChange={handleUpload}
                fullWidth={true}
                size={'small'}
            />
            {isUploading && <div>
                <Alert key={"primary"} variant={"primary"}>
                    <ProgressBar animated now={uploadPercentage} label={`${uploadPercentage}%`}/>
                    Uploading...Please wait
                </Alert>
            </div>

            }
        </>

    )
}
